/* unplugin-vue-components disabled */import { render } from "./DrawingCanvas.vue?vue&type=template&id=5e41efab&scoped=true"
import script from "./DrawingCanvas.vue?vue&type=script&lang=js"
export * from "./DrawingCanvas.vue?vue&type=script&lang=js"

import "./DrawingCanvas.vue?vue&type=style&index=0&id=5e41efab&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e41efab"]])

export default __exports__